import { Component, Input, inject } from '@angular/core';

// Services
import { NetworkService } from '../../../core/services/network/network.service';

@Component({
  selector: 'not-available-offline',
  templateUrl: './not-available-offline.component.html',
  standalone: false,
})
export class NotAvailableOfflineComponent {
  network = inject(NetworkService);

  @Input() featureNotAvailable: string = undefined;
}
